import axios from "axios";
import i18n from "@/i18n";
import TokenService from "@/services/common/auth/TokenService";
import DateTimeHandler from "@/services/common/date-time/DateTimeHandlerService";
import DateTimeHandlerServiceV2 from "@/services/common/date-time/DateTimeHandlerServiceV2";

export const http = axios.create({
	 baseURL: process.env.VUE_APP_API_AQTECH,
	 headers: {
			 Accept:  "application/json",
			 Content: "application/json",
	 },
	 });

export const httpV2 = axios.create({
	baseURL: process.env.VUE_APP_API_AQTECH_V2,
	headers: {
		Accept:  "application/json",
		Content: "application/json",
	},
});

http.interceptors.request.use((config) =>
{
	const token = TokenService.GetSessionCookie();
	if (token)
	{
		config.headers.Authorization = `Bearer ${token}`;
	}
	const { locale } = i18n;
	if (locale)
	{
		config.headers["Accept-Language"] = locale;
		config.headers["TimeOffset"] = DateTimeHandlerServiceV2.GetUserOffset();
		config.headers["DateTimeFormat"] = DateTimeHandler.GetDateTimeFormat();
	}
	return config;
}, erro => Promise.reject(erro));

httpV2.interceptors.request.use((config) =>
{
	const token = TokenService.GetSessionCookie();
	if (token)
	{
		config.headers.Authorization = `Bearer ${token}`;
	}
	const { locale } = i18n;
	if (locale)
	{
		config.headers["Accept-Language"] = locale;
		config.headers["TimeOffset"] = DateTimeHandlerServiceV2.GetUserOffset();
		config.headers["DateTimeFormat"] = DateTimeHandler.GetDateTimeFormat();
	}
	return config;
}, erro => Promise.reject(erro));
